import { arrayFromJSONValue, floatFromJSONValue, intOptionalFromJSONValue, stringFromJSONValue } from './parser'

class MapLayerAttachmentModel {
  file: string
  name: string
  type: string
  refresh?: number

  public constructor(
    file: string, 
    name: string, 
    type: string,
    refresh?: number,
  ) {
    this.file = file
    this.name= name
    this.type = type
    this.refresh = refresh
  }

  public static modelFromJSON(json: any): MapLayerAttachmentModel {
    return new MapLayerAttachmentModel(
      stringFromJSONValue(json['File']),
      stringFromJSONValue(json['Name']),
      stringFromJSONValue(json['Type']),
      intOptionalFromJSONValue(json['Refresh']),
    )
  }

  public getURL = () => {
    return this.file.startsWith("/") ? `${process.env.REACT_APP_API_URL}/v1${this.file}` : this.file
  }
  public isImage = () => {
    return this.type === 'image/png' || this.type === 'image/jpeg' || this.type === 'image/jpg'
  }
  public isVideo = () => {
    return this.type === 'application/x-mpegURL'
  }
}

export class MapLayerModel {
  id: string
  itemId: string
  itemName: string
  icon: string
  latitude: number
  longitude: number
  info: {}
  attachments: MapLayerAttachmentModel[]

  public constructor(
    id: string, 
    itemId: string, 
    itemName: string,
    icon: string, 
    latitude: number,
    longitude: number,
    info: {},
    attachments: MapLayerAttachmentModel[]
  ) {
    this.id = id
    this.itemId= itemId
    this.itemName = itemName
    this.icon = icon
    this.latitude = latitude
    this.longitude = longitude
    this.info = info
    this.attachments = attachments
  }

  public static modelFromJSON(json: any): MapLayerModel {
    return new MapLayerModel(
      stringFromJSONValue(json['ID']),
      stringFromJSONValue(json['ItemID']),
      stringFromJSONValue(json['ItemName']),
      stringFromJSONValue(json['Icon']),
      floatFromJSONValue(json['LatitudeLongitude'].split(',')[0]),
      floatFromJSONValue(json['LatitudeLongitude'].split(',')[1]),
      json['Info'],
      arrayFromJSONValue(json['Attachments'])
              .map(value => MapLayerAttachmentModel.modelFromJSON(value))
    )
  }
}
